import { MRT_ColumnDef, MRT_PaginationState } from "material-react-table";
import { useState } from "react";
import { Box, Button, Chip, IconButton, Typography } from "@mui/material";
import { Delete, Edit, RemoveRedEye } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataTable } from "../../libs/core/components/data-table";
import { Unit } from "./types/unit";
import { ConfirmModal } from "../../libs/ui/modal/confirm_modal";
import { useDeleteUnitMutation, useGetUnitsQuery } from "./api/unitApi";
import AddEditUnit from "./components/AddEditUnits";

const UnitManager: React.FC = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState<Unit | null>(null);
  const navigate = useNavigate();

  const { data:units, isLoading, isError, isFetching, refetch } = useGetUnitsQuery();
  const [deleteUnit] = useDeleteUnitMutation();
  const columns: Array<MRT_ColumnDef<Unit>> = [
    {
      header: "Unit Code",
      accessorKey: "unit_code",
      size: 80,
    },
    {
      header: "Project",
      accessorKey: "project.title",
      size: 100,
    },
    {
      header: "Type",
      accessorKey: "unit_type.name",
      size: 60,
    },
    {
      header: "Size (sqm)",
      accessorKey: "size_sqm",
      size: 50,
    },
    {
      header: "Price Range",
      accessorFn: (row) => `${row.price_min} - ${row.price_max}`,
      size: 80,
    },
    {
      header: "Bedrooms",
      accessorKey: "bedrooms",
      size: 30,
    },
    {
      header: "Bathrooms",
      accessorKey: "bathrooms",
      size: 30,
    },
    {
      header: "Availability",
      accessorKey: "availability",
      size: 60,
      Cell({ row: { original } }) {
        return (
          <Chip
            label={original.availability}
            color={original.availability === "Available" ? "success" : "default"}
            variant="outlined"
          />
        );
      },
    },
    {
      header: "Special Features",
      accessorKey: "special_features",
      size: 120,
      Cell({ row: { original } }) {
        return (
          <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
            {original.special_features.map((feature, index) => (
              <Chip key={index} label={feature} size="small" />
            ))}
          </Box>
        );
      },
    },
  ];

  return (
    <Box>
      <DataTable<Unit>
        toolbar={
          <Box display="flex" alignItems="center" width="100%">
            <Box display="flex" gap={3} alignItems="center" flex="1">
              <Typography variant="h6">Units</Typography>
              <Chip
                color="primary"
                variant="outlined"
                label={`${units?.data?.length ?? 0} Units`}
              />
            </Box>
            <Button
              onClick={() => {
                setSelectedUnit(null);
                setOpenDialog(true);
              }}
              sx={{ minWidth: "200px" }}
              variant="contained"
            >
              Add New Unit
            </Button>
          </Box>
        }
        list={units?.data ?? []}
        count={units?.data?.length ?? 0}
        columns={columns}
        getRowId={(row) => row?.id?.toString()}
        isLoading={isLoading}
        isSuccess={!isError}
        isError={isError}
        isFetching={isFetching}
        pagination={pagination}
        onPaginationChange={setPagination}
        // onRowClick={(row) => navigate(`/units/${row.id}`)}
        renderRowActions={(row) => (
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/units/${row?.id}`);
              }}
            >
              <RemoveRedEye />
            </IconButton>
            <IconButton
              color="warning"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUnit(row);
                setOpenEditDialog(true);
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedUnit(row);
                setOpenConfirmModal(true);
              }}
            >
              <Delete />
            </IconButton>
          </Box>
        )}
      />
      <AddEditUnit
        open={openDialog}
        unit={selectedUnit}
        onSuccess={refetch}
        setModalOpen={(val)=>setOpenDialog(val)}

        
        // onClose={() => {
        //   setOpenDialog(false);
        //   setOpenEditDialog(false);
        // }}
      />
 <AddEditUnit
        open={openEditDialog}
        unit={selectedUnit}
        onSuccess={refetch}
        setModalOpen={(val)=>setOpenEditDialog(val)}

        
        // onClose={() => {
        //   setOpenDialog(false);
        //   setOpenEditDialog(false);
        // }}
      />
      <ConfirmModal
      type= "warning"
      setModalOpen={(val)=>setOpenConfirmModal(val)}
        modalOpen={openConfirmModal}
        onCancel={() => setOpenConfirmModal(false)}
        onOk={async () => {
          if (selectedUnit) {
            await deleteUnit(`${selectedUnit.id}`);
            setOpenConfirmModal(false);
          }
        }}
        title="Delete Unit"
        message={`Are you sure you want to delete unit ${selectedUnit?.unit_code}?`}
      />
    </Box>
  );
};

export default UnitManager;
